import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../store/hooks";
import { fetchGapCasinoLaunchUrl } from "../../store/slices/casinoSlice";
import "./MlobbyIframeNew.scss";

// this was same in fairplay
const MLOBBY_GAME_ID = "902000";
const MLOBBY_PROVIDER = "RG";
const MLOBBY_CATEGORY = "Game Lobby";
const GAME_CODE = "YG-MLOBBY";

const useNarrowMobile = () => {
  const [narrow, setNarrow] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < 720 : false,
  );

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const mq = window.matchMedia("(max-width: 719px)");
    const sync = () => setNarrow(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);

  return narrow;
};

//this component is simply to render mini games casino from iframe
const MlobbyIframeNew = () => {
  const dispatch = useAppDispatch();
  const narrow = useNarrowMobile();
  const loggedIn = useSelector((state) => !!(state.auth?.user || state.auth?.token));
  const langData = useSelector((state) => state.common?.langData);

  const [gameSrc, setGameSrc] = useState("");
  const [loading, setLoading] = useState(false);
  const panelRef = useRef(null);

  useEffect(() => {
    if (!narrow || !loggedIn) return undefined;

    //fairplay had settimeout so i added same here
    const t = setTimeout(() => {
      const run = async () => {
        setLoading(true);
        try {
          const result = await dispatch(
            fetchGapCasinoLaunchUrl({
              category: MLOBBY_CATEGORY,
              gameId: MLOBBY_GAME_ID,
              providerName: MLOBBY_PROVIDER,
            }),
          ).unwrap();
          const url = result?.launchUrl || "";
          if (url) setGameSrc(url);
        } catch {
          /* keep iframe empty on failure */
        } finally {
          setLoading(false);
        }
      };
      run();
    }, 3000);

    return () => clearTimeout(t);
  }, [dispatch, loggedIn, narrow]);

  if (!narrow) return null;

  const closePanel = () => {
    panelRef.current?.classList.add("d-none");
    const routerEl = document.getElementsByClassName("router-ctn")[0];
    if (routerEl) {
      routerEl.style.maxHeight = "100vh";
      routerEl.style.overflowY = "auto";
    }
    document
      .getElementsByClassName("mini-casino-btn")[0]
      ?.classList.remove("d-none");
  };

  return (
    <>
      <div ref={panelRef} className="mlobby-main-dc d-none">
        <div
          className="mini-iframe-close-btn"
          onClick={closePanel}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              closePanel();
            }
          }}
          aria-label="Close mini casino"
        >
          <i className="bi bi-chevron-down" aria-hidden="true" />
        </div>
        <div className="dc-iframe-ctn-mlobby">
          {loading && !gameSrc ? (
            <span className="text-white small">Loading…</span>
          ) : (
            <iframe
              src={gameSrc}
              title={langData?.["dc_game"] || "Casino lobby"}
              allowFullScreen
              sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default MlobbyIframeNew;
